import { Divider, ThemeUIStyleObject } from 'theme-ui'
import React from 'react'

export default function SectionDivider({ sx }: { sx?: ThemeUIStyleObject }): React.ReactElement {
  return (
    <Divider
      sx={{
        width: '100%',
        height: '1px',
        color: 'blueYonder20',
        my: ['8rem', '10rem'],
        ...sx,
      }}
    />
  )
}
